export function removeNullValues(obj: Record<string, any>): Record<string, string> {
  return Object.entries(obj)
    .filter(([_, value]) => value !== null)
    .reduce((acc, [key, value]) => {
        acc[key] = String(value); // Convert to string if necessary
        return acc;
    }, {} as Record<string, string>);
}